/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuFilterLocation_viewer$ref = any;
export type SbSharedRefineMenuFilterDeliveryOptions_viewer$ref = any;
export type SbSharedRefineMenuFilterDeliveryOptions_viewer = {
    readonly isDeliveryOptionsDisabled: boolean | null;
    readonly " $fragmentRefs": SbSharedRefineMenuFilterLocation_viewer$ref;
    readonly " $refType": SbSharedRefineMenuFilterDeliveryOptions_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuFilterDeliveryOptions_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isDeliveryOptionsDisabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "DISABLE_SB_DELIVERY_OPTION_FILTERS"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_SB_DELIVERY_OPTION_FILTERS\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuFilterLocation_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '52f870be18274b0d0153a7563b029072';
export default node;
